<template>
  <div class="AllPwaMobile waitingDriver" style="background: #fff">
    <div v-if="!start_service">
      <img src="@/assets/img/search-car.gif" />
      <div class="ShowTitleToUserService">
        <p>لطفا منتظر بمانید</p>
        <p class="sub-title">
          سیستم در حال یافتن نزدیک‌ترین راننده برای سرویس شماست.
        </p>
      </div>

      <button
        v-if="!loading"
        class="waitingCancleBtn"
        @click="cancel_service()"
      >
        لغو سرویس
      </button>

      <div v-if="loading" class="waitingCancleBtn">
        <div class="whiteLoader"></div>
      </div>
    </div>

    <currentService
      :ChatOpen="ChatOpen"
      v-if="start_service"
      :DriverLocation="DriverLocation"
      :StatusEn="StatusEn"
      :ServiceData="newservice_data"
    />
  </div>

  <vue-bottom-sheet
    :can-swipe="false"
    ref="issheet4"
    style="z-index: 1050"
    v-model="issheet_rating"
  >
    <div style="height: 160px">
      <div class="rateTitle">به این سفر امتیاز دهید</div>
      <div
        style="
          color: #df1b1b;
          font-weight: 800;
          font-size: 18px;
          justify-content: center;
          display: flex;
          align-content: center;
          margin-top: 13px;
        "
        class="mt-3 text-center"
      >
        <vue3-star-ratings
          half-increments
          hover
          :length="5"
          :size="41"
          v-model="rate_val"
          class="mt-1"
          starColor="#f39c12"
          inactiveColor="#bdc3c7"
        />
      </div>
      <div>
        <button v-if="!rateLoading" class="rateSubmit" @click="rate_submit()">
          ثبت نظر
        </button>
        <div v-if="rateLoading" class="rateSubmit">
          <div class="whiteLoader"></div>
        </div>
      </div>
    </div>
  </vue-bottom-sheet>
</template>

<script>
import currentService from "@/components/taxi/currentService";
// import { LocalNotifications } from '@capacitor/local-notifications';
// import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { mapGetters } from "vuex";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { initSocket, disconnectSocket } from "./WebSocketService";

export default {
  name: "waiting_driver",
  components: {
    // PerfectScrollbar,
    currentService,
    VueBottomSheet,
  },
  computed: {
    ...mapGetters([
      "baseUrl",
      "auth_taxi",
      "taxi_c_set",
      "current_service_info",
    ]),
  },

  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      newservice_data: [],
      snackbar: false,
      text: "",
      loading: false,
      snackbar_color: "",
      audioSrc: "/app/media/service.86ffa798.mp3",
      playing: false,
      Status: "",
      StatusEn: "",
      start_service: false,
      issheet_rating: false,
      rate_val: 1,
      driver_id: 0,
      cells: Array(9).fill(null),
      winner: null,
      isDraw: false,
      playerScore: 0,
      computerScore: 0,
      service_id: 0,
      ChatOpen: false,
      DriverLocation: {},
    };
  },
  async mounted() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/socket-worker.js")
        .then((registration) => {
          console.log("سرویس‌ورکر با دامنه ثبت شد:", registration.scope);
        })
        .catch((error) => {
          console.error("ثبت سرویس‌ورکر ناموفق بود:", error);
        });

      navigator.serviceWorker.onmessage = (event) => {
        console.log("پیام از سرویس ورکر:", event.data);
        const action = event.data.action;
        this.typeSound = action;
      };
    }
    var self = this;
    console.log("this.current_service_info", this.current_service_info);
    if (
      this.current_service_info &&
      this.current_service_info.data.data != undefined
    ) {
      // console.log('service id:'+self.current_service_info.data.data.service_id);
      this.service_id = self.current_service_info.data.data.service_id;
      if (
        self.current_service_info.data.result == 1 &&
        self.current_service_info.data.data.driver_id > 0
      ) {
        this.start_service = true;
        console.log("status:" + self.current_service_info.data.data.status);
        this.StatusEn = self.current_service_info.data.data.status;
        this.newservice_data = self.current_service_info.data.data;
      } else if (self.current_service_info.data.result == 0) {
        // console.log('111qq',self.current_service_info.data.result);
        let self = this;
        self.$router.push({ name: "manualService" });
      }
    } else {
      // console.log('222qq',);
      let self = this;
      self.$router.push({ name: "manualService" });
    }
    const uid = this.auth_taxi.uid;
    disconnectSocket();
    const socket = initSocket(uid, this.taxi_c_set.server_ip);
    socket.on("api_service", (data) => {
      console.log(data);
      var action = data.action;
      var self = this;
      if (action == "driver_accepted_service") {
        console.log("accepted driver:", data);
        self.newservice_data = data;

        self.start_service = true;
        self.driver_id = data.driver_id;
        self.service_id = data.service_id;
        self.StatusEn = "accept";
      }
      if (action == "driver_arrived") {
        // راننده به مبدا رسیده است
        self.snackbar = true;
        self.snackbar_color = "info";
        toast.success("مسافر محترم راننده به مبدا رسیده است");
        self.Status = "حرکت به سمت مبداء";
        self.StatusEn = "waiting_customer";
        self.newservice_data = data;
        // self.scheduleNotificationStart();
        self.play_sound("/alarms/message.mp3");
      }
      if (action == "start_service") {
        // راننده سرویس را تایید کرد
        self.Status = "در حال جابه جایی مسافر";
        self.StatusEn = "moving";
        self.snackbar = true;
        self.snackbar_color = "info";
        self.text = "آغاز سرویس";
        self.newservice_data = data;
        self.play_sound("/alarms/message.mp3");
      }
      if (action == "service_completed") {
        // سرویس به پایان رسید
        self.snackbar = true;
        self.snackbar_color = "info";
        toast.success("مسافر محترم سرویس شما به پایان رسید لطفا امتیاز دهید");
        this.$refs.issheet4.open();
        this.issheet_rating = false;
        self.StatusEn = "finish";
        self.newservice_data = data;
        self.scheduleNotificationScore();
        self.play_sound("/alarms/message.mp3");
      }
      if (action == "cancel_service") {
        self.play_sound("/alarms/cancel.mp3");
        self.$router.push({ name: "manualService" });
      }
      if (action == "service_canceled_by_driver") {
        // سرویس کنسل گردید
        self.snackbar = true;
        self.snackbar_color = "info";
        self.newservice_data = data;
        self.start_service = false;
        toast.error(
          "مسافر محترم سرویس شما از سمت راننده کنسل شد منتظر تایید توسط راننده دیگر باشید"
        );
        self.scheduleNotificationCancel();
        self.play_sound("/alarms/message.mp3");
      }
      if (action == "driver_location_update") {
        //console.log(data);
        if (data.driver_id == self.newservice_data.driver_id) {
          self.DriverLocation = { lat: data.driver_lat, lng: data.driver_lng };
        }
      }
      if (action == "chat_service") {
        console.log(data);
        if (data.service_id == self.newservice_data.service_id) {
          this.ChatOpen = true;
          self.play_sound("/alarms/message.mp3");
        }
      }
    });
  },
  methods: {
    play_sound(src) {
      console.log(src);
      var audio = new Audio(src);
      audio.load();
      audio.play().catch((error) => {
        console.error("Error playing sound:", error);
      });
    },
    // async scheduleNotificationScore() {
    //   // درخواست مجوز برای ارسال نوتیفیکیشن
    //   const permission = await LocalNotifications.requestPermissions();
    //
    //   if (permission.display === 'granted') {
    //     // تنظیم یک نوتیفیکیشن محلی
    //     await LocalNotifications.schedule({
    //       notifications: [
    //         {
    //           id: 1,
    //           title: 'پایان سرویس دهی',
    //           body: 'مسافر محترم سفر  به اتمام رسید لطفا امتباز دهید',
    //           schedule: { at: new Date(Date.now() + 1000 * 2) }, // نوتیفیکیشن پس از 2 ثانیه ارسال شود
    //           sound: null,
    //           attachments: null,
    //           actionTypeId: '',
    //           extra: null,
    //         },
    //       ],
    //     });
    //   } else {
    //     console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
    //   }
    // },
    // async scheduleNotificationStart() {
    //   const permission = await LocalNotifications.requestPermissions();
    //   if (permission.display === 'granted') {
    //     await LocalNotifications.schedule({
    //       notifications: [
    //         {
    //           id: 1,
    //           title: 'راننده رسید',
    //           body: 'مسافر محترم راننده به مبداء رسیده است',
    //           schedule: { at: new Date(Date.now() + 1000 * 2) }, // نوتیفیکیشن پس از 2 ثانیه ارسال شود
    //           sound: null,
    //           attachments: null,
    //           actionTypeId: '',
    //           extra: null,
    //         },
    //       ],
    //     });
    //   } else {
    //     console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
    //   }
    // },
    // async scheduleNotificationCancel() {
    //   const permission = await LocalNotifications.requestPermissions();
    //   if (permission.display === 'granted') {
    //     await LocalNotifications.schedule({
    //       notifications: [
    //         {
    //           id: 1,
    //           title: 'انصراف از سرویس',
    //           body: 'سرویس از طرف راننده کنسل شد و در انتظار تایید راننده دیگر ',
    //           schedule: { at: new Date(Date.now() + 1000 * 2) },
    //           sound: null,
    //           attachments: null,
    //           actionTypeId: '',
    //           extra: null,
    //         },
    //       ],
    //     });
    //   } else {
    //     console.log('دسترسی به ارسال نوتیفیکیشن محلی داده نشد.');
    //   }
    // },
    rate_submit() {
      let self = this;
      self.loading = true;
      this.helperPost_taxi("customer-save-rate", {
        driver_id: self.driver_id,
        uid: this.auth_taxi.uid,
        service_id: this.service_id,
        rating: self.rate_val,
      })
        .then(function (r) {
          console.log(r);
          self.$refs.issheet4.close();
          toast.success("امتیاز با موفقیت ثبت گردید");
          setTimeout(function () {
            self.$router.push({ name: "manualService" });
          }, 1000);
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    cancel_service() {
      let self = this;
      this.loading = true;
      this.helperPost_taxi("customer-cancel-service", {
        service_id: this.service_id,
        uid: this.auth_taxi.uid,
      })
        .then((r) => {
          if (r.data.result === "1") {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
            setTimeout(function () {
              self.$router.push({ path: "/taxi/manualService" });
            }, 1000);
          } else if (r.data.result === "0") {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          } else {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          }
          this.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },

    makeMove(index) {
      if (!this.cells[index] && !this.winner) {
        this.cells[index] = this.currentPlayer;
        this.checkWinner();
        if (!this.winner) {
          this.currentPlayer = "O";
          this.aiMove();
        }
      }
    },
    aiMove() {
      const bestMove = this.findBestMove();
      this.cells[bestMove] = this.currentPlayer;
      this.checkWinner();
      this.currentPlayer = "X";

      if (this.winner || this.isDraw) {
        this.resetGame();
      }
    },
    findBestMove() {
      let bestVal = -Infinity;
      let bestMove = -1;

      for (let i = 0; i < 9; i++) {
        if (this.cells[i] === null) {
          this.cells[i] = "O";
          const moveVal = this.minimax(0, false);
          this.cells[i] = null;

          if (moveVal > bestVal) {
            bestMove = i;
            bestVal = moveVal;
          }
        }
      }
      return bestMove;
    },
    minimax(depth, isMaximizing) {
      const scores = {
        X: -10,
        O: 10,
        tie: 0,
      };

      const winner = this.checkWinnerCondition();
      if (winner) {
        return scores[winner];
      }

      if (isMaximizing) {
        let bestVal = -Infinity;

        for (let i = 0; i < 9; i++) {
          if (this.cells[i] === null) {
            this.cells[i] = "O";
            bestVal = Math.max(bestVal, this.minimax(depth + 1, false));
            this.cells[i] = null;
          }
        }
        return bestVal;
      } else {
        let bestVal = Infinity;

        for (let i = 0; i < 9; i++) {
          if (this.cells[i] === null) {
            this.cells[i] = "X"; // کاربر
            bestVal = Math.min(bestVal, this.minimax(depth + 1, true));
            this.cells[i] = null; // بازگرداندن حالت اولیه
          }
        }
        return bestVal;
      }
    },
    checkWinner() {
      const winner = this.checkWinnerCondition();
      if (winner) {
        this.winner = winner;

        if (winner === "X") {
          this.playerScore++;
        } else {
          this.computerScore++;
        }

        setTimeout(() => {
          this.resetGame();
        }, 1000);
      } else if (this.cells.every((cell) => cell)) {
        this.isDraw = true;
      }
    },
    beforeRouteLeave() {
      this.socket.destIconStyle;
      disconnectSocket();
      // if (this.watcherId) {
      //   BackgroundGeolocation.removeWatcher({ id: this.watcherId });
      // }
    },
    checkWinnerCondition() {
      const winPatterns = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6],
      ];

      for (const pattern of winPatterns) {
        const [a, b, c] = pattern;
        if (
          this.cells[a] &&
          this.cells[a] === this.cells[b] &&
          this.cells[a] === this.cells[c]
        ) {
          return this.cells[a]; // برنده
        }
      }
      return null; // هیچ برنده‌ای وجود ندارد
    },
    resetGame() {
      this.cells = Array(9).fill(null);
      this.currentPlayer = "X";
      this.winner = null;
      this.isDraw = false;
    },
  },
};
</script>

<style scoped></style>

<style scoped>
.waitingCancleBtn {
  width: 90%;
  height: 50px;
  border-radius: 16px;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  background: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  font-family: "iranyekanB", sans-serif;
}

.waitingDriver {
  width: 100%;
  height: 100vh;
  position: relative;
}

.rateTitle {
  font-family: "iranyekanB", sans-serif;
  text-align: center;
  font-size: 1.05rem;
  color: #000;
}

:deep(.vue3-star-ratings__icon) {
  width: 22px !important;
  height: 22px !important;
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.rateSubmit {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 50px;
  border-radius: 10px;
  color: #fff !important;
  font-size: 1rem;
  font-weight: 500;
  background: #34be73;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin-top: 16px;
}

.waitingAds {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px 0;

  img {
    width: 100%;
    max-height: 132px;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
</style>
